// extracted by mini-css-extract-plugin
export default {"hobbies__title":"style_hobbies__title__FU2MT","hobbies__item":"style_hobbies__item__orkEX","hobbies__emoji":"style_hobbies__emoji__vyyHO"};